import React, { useEffect } from 'react';

const Privacy = () => {
  useEffect(() => {
    // Nasconde la pagina ai motori di ricerca (no indicizzazione su Google)
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow, noarchive, nosnippet';
    document.head.appendChild(meta);

    // Sovrascrive eventuale meta robots globale presente in index.html
    const existing = document.querySelector('meta[name="robots"]:not([content*="noindex"])');
    if (existing) existing.setAttribute('content', 'noindex, nofollow, noarchive, nosnippet');

    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
      if (existing) existing.setAttribute('content', 'index, follow');
    };
  }, []);

  return (
    <div className="page">
      <section className="section">
        <div className="container">
          <h1 className="page-title">Privacy Policy</h1>
          <p className="page-subtitle">Informativa sulla Privacy ai sensi del GDPR (Regolamento UE 2016/679)</p>
          
          <div className="privacy-content">
            <div className="privacy-section">
              <h2>1. Titolare del Trattamento</h2>
              <p>
                <strong>SI.SA. LINE S.r.l.</strong><br />
                Sede legale: Via Monferrato, 20 - 20098 San Giuliano Milanese (MI)<br />
                Email: info@sisaline.it<br />
                P.IVA: [Inserire P.IVA]
              </p>
            </div>

            <div className="privacy-section">
              <h2>2. Tipologie di Dati Raccolti</h2>
              <p>
                Il sito www.sisaline.it raccoglie i seguenti dati personali forniti volontariamente dagli utenti tramite il form di contatto:
              </p>
              <ul>
                <li>Nome e Cognome</li>
                <li>Indirizzo email</li>
                <li>Numero di telefono</li>
                <li>Messaggio/Richiesta</li>
              </ul>
              <p>
                Inoltre, il sito raccoglie automaticamente dati di navigazione tramite log del server e cookie tecnici necessari al funzionamento del sito.
              </p>
            </div>

            <div className="privacy-section">
              <h2>3. Finalità del Trattamento</h2>
              <p>I dati personali raccolti vengono trattati per le seguenti finalità:</p>
              <ul>
                <li><strong>Richieste di contatto:</strong> rispondere alle richieste di informazioni, preventivi e assistenza inviate tramite il form di contatto.</li>
                <li><strong>Comunicazioni commerciali:</strong> solo previo consenso esplicito, inviare comunicazioni relative ai nostri servizi e offerte.</li>
                <li><strong>Obblighi di legge:</strong> adempiere agli obblighi previsti dalla legge, regolamenti e normative vigenti.</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>4. Base Giuridica del Trattamento</h2>
              <p>Il trattamento dei dati personali si basa su:</p>
              <ul>
                <li><strong>Consenso dell'interessato</strong> (art. 6, par. 1, lett. a) GDPR) per l'invio di comunicazioni commerciali.</li>
                <li><strong>Esecuzione di misure precontrattuali</strong> (art. 6, par. 1, lett. b) GDPR) per rispondere alle richieste di preventivo.</li>
                <li><strong>Legittimo interesse</strong> (art. 6, par. 1, lett. f) GDPR) per gestire le richieste di contatto e fornire assistenza.</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>5. Modalità di Trattamento</h2>
              <p>
                I dati personali sono trattati con strumenti informatici e telematici. Vengono adottate tutte le misure di sicurezza tecniche e organizzative necessarie per garantire la protezione dei dati contro accessi non autorizzati, perdita o distruzione.
              </p>
            </div>

            <div className="privacy-section">
              <h2>6. Conservazione dei Dati</h2>
              <p>
                I dati personali saranno conservati per il tempo strettamente necessario al raggiungimento delle finalità per cui sono stati raccolti:
              </p>
              <ul>
                <li><strong>Richieste di contatto:</strong> i dati saranno conservati per 12 mesi dalla ricezione della richiesta.</li>
                <li><strong>Comunicazioni commerciali:</strong> fino alla revoca del consenso da parte dell'interessato.</li>
                <li><strong>Obblighi di legge:</strong> per il periodo previsto dalle normative vigenti (es. 10 anni per documenti fiscali).</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>7. Comunicazione e Diffusione dei Dati</h2>
              <p>
                I dati personali non saranno diffusi a terzi. Potranno essere comunicati esclusivamente a:
              </p>
              <ul>
                <li>Dipendenti e collaboratori di SI.SA. LINE S.r.l. incaricati del trattamento.</li>
                <li>Fornitori di servizi tecnici (hosting, email) designati come Responsabili del Trattamento ai sensi dell'art. 28 GDPR.</li>
                <li>Autorità pubbliche e organi di vigilanza, quando richiesto dalla legge.</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>8. Diritti dell'Interessato</h2>
              <p>
                Ai sensi degli artt. 15-22 del GDPR, l'interessato ha diritto di:
              </p>
              <ul>
                <li><strong>Accesso:</strong> ottenere conferma dell'esistenza dei propri dati e riceverne copia.</li>
                <li><strong>Rettifica:</strong> richiedere la correzione di dati inesatti o incompleti.</li>
                <li><strong>Cancellazione:</strong> richiedere la cancellazione dei dati personali (diritto all'oblio).</li>
                <li><strong>Limitazione:</strong> richiedere la limitazione del trattamento.</li>
                <li><strong>Portabilità:</strong> ricevere i dati in formato strutturato e leggibile.</li>
                <li><strong>Opposizione:</strong> opporsi al trattamento dei dati per finalità di marketing.</li>
                <li><strong>Revoca del consenso:</strong> revocare in qualsiasi momento il consenso prestato.</li>
              </ul>
              <p>
                Per esercitare i propri diritti, l'interessato può inviare una richiesta a: <strong>info@sisaline.it</strong>
              </p>
              <p>
                L'interessato ha inoltre diritto di proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).
              </p>
            </div>

            <div className="privacy-section">
              <h2>9. Cookie</h2>
              <p>
                Il sito www.sisaline.it utilizza esclusivamente cookie tecnici necessari al funzionamento del sito e alla navigazione. Non vengono utilizzati cookie di profilazione o tracciamento.
              </p>
            </div>

            <div className="privacy-section">
              <h2>10. Modifiche alla Privacy Policy</h2>
              <p>
                SI.SA. LINE S.r.l. si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
              </p>
              <p><strong>Ultimo aggiornamento: 25 marzo 2025</strong></p>
            </div>

            <div className="privacy-section">
              <h2>11. Contatti</h2>
              <p>
                Per qualsiasi informazione relativa alla presente Privacy Policy o per esercitare i diritti previsti dal GDPR, è possibile contattare:
              </p>
              <p>
                <strong>SI.SA. LINE S.r.l.</strong><br />
                Email: info@sisaline.it<br />
                Telefono: +39 [Numero principale]<br />
                Indirizzo: Via Monferrato, 20 - 20098 San Giuliano Milanese (MI)
              </p>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .page {
          min-height: 100vh;
          background: var(--bg-primary);
        }

        .section {
          padding: var(--space-xl) var(--space-md);
        }

        .container {
          max-width: 900px;
          margin: 0 auto;
        }

        .page-title {
          font-size: 2.5rem;
          font-weight: 800;
          color: var(--text-primary);
          margin-bottom: var(--space-sm);
          text-align: center;
        }

        .page-subtitle {
          font-size: 1rem;
          color: var(--text-secondary);
          text-align: center;
          margin-bottom: var(--space-xl);
          font-style: italic;
        }

        .privacy-content {
          background: var(--bg-card);
          border-radius: 1rem;
          padding: var(--space-lg);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }

        .privacy-section {
          margin-bottom: var(--space-lg);
          padding-bottom: var(--space-lg);
          border-bottom: 1px solid var(--border-light);
        }

        .privacy-section:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .privacy-section h2 {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--brand-orange);
          margin-bottom: var(--space-md);
        }

        .privacy-section p {
          color: var(--text-secondary);
          line-height: 1.8;
          margin-bottom: var(--space-sm);
        }

        .privacy-section ul {
          margin-left: var(--space-md);
          margin-bottom: var(--space-sm);
        }

        .privacy-section li {
          color: var(--text-secondary);
          line-height: 1.8;
          margin-bottom: 0.5rem;
        }

        .privacy-section strong {
          color: var(--text-primary);
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .page-title {
            font-size: 2rem;
          }

          .privacy-content {
            padding: var(--space-md);
          }

          .privacy-section h2 {
            font-size: 1.25rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Privacy;
